
import ls from 'localstorage-slim'
import { logoutAndRedirectToLogin } from "../helpers/function";

export const verifyTokenExpire = () => {
    let now = new Date();
    let expireDate = new Date(ls.get('date_expire'));
    if(now > expireDate){
        logoutAndRedirectToLogin();
        return false;
    }
    return true;
}

export const verifyTokenMinutes = ()  => {
    let now = new Date();
    let expireDate = new Date(ls.get('date_expire'));
    let diffInMinutes = Math.floor((expireDate - now) / 1000 / 60);
    if(diffInMinutes <= 5){  // Si le nombre de minutes restant <= 5, alors on rafraichit le token
        return true;
    }
    return false;
}
